export default __webpack_public_path__ + "static/media/housing.1cc5633a.png";